module.exports = __webpack_public_path__ + "static/media/Riviera_Maya_Resort_Mexico.bc3b69fc.png";